<template>
  <div>

    <!-- Stage -->
    <!-- <TavolosWidget :restaurant_id="216"></TavolosWidget> -->

  </div>
</template>

<script>

  import TavolosWidget from './components/TavolosWidget.vue'
  export default {
    components: {
      TavolosWidget
    },
    data () {
      return {

      }
    }
  }
</script>

<style lang="scss">
  body {
    position: relative;
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue